var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLinkNextWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons-navigation/Next/White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.9999,19.9864 C0.7569,19.9864 0.5129,19.8984 0.3209,19.7194 C-0.0841,19.3444 -0.1091,18.7124 0.2659,18.3064 L7.9729,9.9814 L0.2669,1.6804 C-0.1081,1.2764 -0.0851,0.6434 0.3199,0.2674 C0.7239,-0.1086 1.3549,-0.0856 1.7329,0.3204 L10.0689,9.3004 C10.4249,9.6834 10.4249,10.2764 10.0699,10.6594 L1.7339,19.6664 C1.5369,19.8794 1.2689,19.9864 0.9999,19.9864",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-navigation/Next/White"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(6.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLinkNextWhite);
export default __webpack_public_path__ + "static/media/arrow-link-next_white.fc9c3686ec7348c9e02e63fd249f7ede.svg";
export { ForwardRef as ReactComponent };